import { render, staticRenderFns } from "./Agenecys.vue?vue&type=template&id=ae0a5050&"
import script from "./Agenecys.vue?vue&type=script&lang=js&"
export * from "./Agenecys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports